import { collection, getDocs } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase/firebase";

const AllWarranty = () => {
  const [filter, setFilter] = useState("All");
  const [warranties, setWarranties] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWarranties = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "warranty"));
        let fetchedWarranties = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // ✅ Ensure all warranties are fetched
        setWarranties(fetchedWarranties);
      } catch (error) {
        console.error("Error fetching warranties:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWarranties();
  }, []);

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handleClick = (status) => {
    navigate("/pv", { state: { status } });
  };

  // ✅ Fix: Always show "All" warranties if no filter is applied
  const filteredWarranties =
    filter === "All"
      ? warranties
      : warranties.filter(
          (warranty) =>
            warranty.status &&
            warranty.status.toUpperCase() === filter.toUpperCase()
        );

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case "PROCESSING":
        return "text-blue-600";
      case "EXPIRED":
        return "text-gray-500";
      case "CLAIMED":
        return "text-green-600";
      case "REJECTED":
        return "text-red-600";
      default:
        return "text-black";
    }
  };

  return (
    <div className="flex flex-col h-full p-4">
      {/* Filter Dropdown */}
      <div className="mb-4 flex justify-end">
        <select
          className="border border-gray-300 rounded-md px-3 py-2 text-sm text-black"
          value={filter}
          onChange={handleFilterChange}
        >
          <option value="All">All</option>
          <option value="PROCESSING">Processing</option>
          <option value="CLAIMED">Claimed</option>
          <option value="EXPIRED">Expired</option>
          <option value="REJECTED">Rejected</option>
        </select>
      </div>

      {/* Show Loading State */}
      {loading ? (
        <div className="flex justify-center items-center h-full text-gray-500 text-lg font-bold">
          Loading warranties...
        </div>
      ) : filteredWarranties.length > 0 ? (
        <div className="overflow-y-auto">
          {filteredWarranties.map((warranty, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-4 mb-4">
              <div className="flex justify-between items-center mb-3">
                <p className={`font-bold ${getStatusColor(warranty.status)}`}>
                  {warranty.status?.toUpperCase()}
                </p>
                <button
                  className="border border-black text-sm px-3 py-1 rounded-md w-40"
                  onClick={() => handleClick(warranty.status)}
                >
                  View
                </button>
              </div>
              <div className="flex justify-between mb-3">
                <p className="text-black font-bold flex-2">{warranty.reason}</p>
                <p className="text-black font-bold flex-1 text-right">
                  {warranty.date}
                </p>
              </div>
              <p className="text-gray-600 text-sm line-clamp-3">
                {warranty.description}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center h-full text-gray-500 text-lg font-bold">
          No Warranties Found 🚫
        </div>
      )}
    </div>
  );
};

export default AllWarranty;
